import React, { useState } from 'react';
import ShadowEmbed from './ShadowEmbed';
import { ShadowEmbedErrorBoundary, ShadowEmbedErrorFallback } from './ShadowEmbedErrorBoundary';

interface ShadowEmbedWrapperProps {
  props: any;
}

export const ShadowEmbedWrapper: React.FC<ShadowEmbedWrapperProps> = ({ props }) => {
  const [retryKey, setRetryKey] = useState(0);


  return (
    <div>
      {/* Shadow Embed with Error Boundary */}
      <ShadowEmbedErrorBoundary fallback={ShadowEmbedErrorFallback}>
        <ShadowEmbed key={retryKey} props={props} />
      </ShadowEmbedErrorBoundary>
    </div>
  );
};

export default ShadowEmbedWrapper;